import { render, staticRenderFns } from "./UUIDLayout.vue?vue&type=template&id=1284eed8&"
import script from "./UUIDLayout.vue?vue&type=script&lang=js&"
export * from "./UUIDLayout.vue?vue&type=script&lang=js&"
import style0 from "./UUIDLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports